export const MuiFormHelperText = {
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                margin: '8px 12px 0 12px',
            },
        },
    },
};
